import { AdministracionComponent } from './Pages/Administracion/administracion.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BaseLayoutComponent } from './Layout/base-layout/base-layout.component';
import { UsuariosComponent } from './Pages/Administracion/usuarios/usuarios.component';
import { LoginComponent } from './Pages/Login/login/login.component';
import { PerfilComponent } from './Pages/Usuario/perfil/perfil.component';
import { DetalleUsuarioComponent } from './Pages/Administracion/usuarios/detalle-usuario/detalle-usuario.component';
import { CrearUsuarioComponent } from './Pages/Administracion/usuarios/crear-usuario/crear-usuario.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { HomeComponent } from './Pages/home/home.component';
import { RecuperarPasswordComponent } from './Pages/Login/login/recuperar-password/recuperar-password.component';
import { RecuperarExitoComponent } from './Pages/Login/login/recuperar-password/recuperar-exito/recuperar-exito.component';
import {IncotermsImportacionesComponent} from "./Pages/importaciones/incoterms-importaciones/incoterms-importaciones.component";
import {DetalleIncotermImportacionComponent} from "./Pages/importaciones/incoterms-importaciones/detalle-incoterm-importacion/detalle-incoterm-importacion.component";

const routes: Routes = [
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'recuperar', component: RecuperarPasswordComponent,
  },
  {
    path: 'recuperar/exito', component: RecuperarExitoComponent,
  },
  {
    path: '',
    component: BaseLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      // Administracion
      {
        path: '',
        component: HomeComponent,
        data: { extraParameter: 'administracionMenu' }
      },
      {
        path: 'administracion',
        children: [
          {
            path: 'personas',
            loadChildren: () => import('./Pages/Administracion/personas/personas.module').then(m => m.PersonasModule),
          },
          {
            path: 'usuarios',
            loadChildren: () => import('./Pages/Administracion/usuarios/usuarios.module').then(m => m.UsuariosModule),
            data: { extraParameter: 'administracionMenu' }
          },
          // {
          //   path: 'modulos',
          //   loadChildren: () => import('./Pages/Administracion/modulos/modulos.module').then(m => m.ModulosModule),
          //   data: { extraParameter: 'administracionMenu' }
          // },
          {
            path: 'roles',
            loadChildren: () => import('./Pages/Administracion/roles/roles.module').then(m => m.RolesModule),
            data: { extraParameter: 'administracionMenu' }
          },
          {
            path: 'auditoria',
            loadChildren: () => import('./Pages/Administracion/auditoria/auditoria.module').then(m => m.AuditoriaModule),
            data: { extraParameter: 'administracionMenu' }
          },
          {
            path: 'parametros-sistema',
            loadChildren: () => import('./Pages/Administracion/parametros-sistema/parametros-sistema.module').then(m => m.ParametrosSistemaModule),
            data: { extraParameter: 'administracionMenu' }
          },
          {
            path: 'parametricos',
            loadChildren: () => import('./Pages/Administracion/parametricos/parametricos.module').then(m => m.ParametricosModule),
            data: { extraParameter: 'administracionMenu' }
          },
        ],
        data: { extraParameter: 'administracionMenu' }
      },
      // Administracion
      { path: 'usuario/perfil-usuario', component: PerfilComponent, data: { extraParameter: 'administracionMenu' } },

      // Notificaciones
      {
        path: 'notificaciones',
        loadChildren: () => import('./Pages/Notificaciones/notificaciones.module').then(m => m.NotificacionesModule),
        data: { extraParameter: 'notificacionesMenu' }
      },
      {
        path: 'requisiciones',
        loadChildren: () => import('./Pages/requisiciones/requisiciones.module').then(m => m.RequisicionesModule),
        data: { extraParameter: 'requisicionesMenu' }
      },
      {
        path: 'autorizacion-facturacion',
        loadChildren: () => import('./Pages/autorizacion-facturacion/autorizacion-facturacion.module').then(m => m.AutorizacionFacturacionModule),
        data: { extraParameter: 'autorizacionFacturacionMenu' }
      },
      {
        path: 'facturas',
        loadChildren: () => import('./Pages/facturas/facturas.module').then(m => m.FacturasModule),
        data: { extraParameter: 'facturasMenu' }
      },
      {
        path: 'recibos',
        loadChildren: () => import('./Pages/recibos/recibos.module').then(m => m.RecibosModule),
        data: { extraParameter: 'recibosMenu' }
      },
      {
        path: 'notas-credito',
        loadChildren: () => import('./Pages/notas-credito/notas-credito.module').then(m => m.NotasCreditoModule),
        data: { extraParameter: 'recibosMenu' }
      },
      {
        path: 'llamado-fiscal',
        loadChildren: () => import('./Pages/llamado-fiscal/llamado-fiscal.module').then(m => m.LlamadoFiscalModule),
        data: { extraParameter: 'llamadoFiscalMenu' }
      },
      {
        path: 'importaciones',
        loadChildren: () => import('./Pages/importaciones/importaciones.module').then(m => m.ImportacionesModule),
        data: { extraParameter: 'importacionesMenu' }
      }
      ,
      {
        path: 'parametricos-requisiciones',
        loadChildren: () => import('./Pages/parametricos-requisiciones/parametricos-requisiciones.module').then(m => m.ParametricosRequisicionesModule),
        data: { extraParameter: 'importacionesMenu' }
      },
      {
        path: 'reportes',
        loadChildren: () => import('./Pages/reportes/reportes.module').then(m => m.ReportesModule),
        data: { extraParameter: 'reportesMenu' }
      }
    ]

  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      useHash: true
    })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
